import type { PlayerSlot } from '@/types/statistics';

/** Sentinel slot indicating the user is not present in a given block. */
export const NOT_PRESENT: PlayerSlot = 'NOT_PRESENT';

/**
 * Master switch for everything built on the backend's `is_winner` flag: the
 * ball map's winner marker and its legend row, and the "most decisive" award
 * on the standouts podium.
 *
 * The flag was distrusted for a long time and the report suppressed it
 * everywhere. The pipeline has since tightened it (a winner now needs a floor
 * bounce, no reply in the rally, a non-serve/non-lob stroke and a trajectory
 * that passed its quality gates), so it is on. Flip to `false` to take winners
 * back out — every call site reads this, so nothing else needs touching.
 */
export const SHOW_WINNERS = true;
